export default {
  name: "bsc",
  chainIds: [97],
  rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
};
